
<h3 class="title-form">*RENTA IMPONIBLE Y DETERMINACIÓN DEL IMPUESTO</h3>
<div class="row" style="padding-left: 1em; padding-right: 1em;">
	<div class="col">
		Ventas:
	</div>
	<div class="col">
		<p class="text-info text-copy" (click)="copy(form.goodsSales+form.servicesSales)" style="text-align:right;">
			{{form.goodsSales+form.servicesSales | currency: 'Q'}}
			<i class="fa fa-copy" tooltip="Copiar al portapapeles" style="display: none;"></i>
		</p>
	</div>
</div>
<div class="row" style="padding-left: 1em; padding-right: 1em;">
	<div class="col">
		Rentas exentas y no afectas acumuladas:
	</div>
	<div class="col">
		<p class="text-info text-copy" (click)="copy(form.withholdings)" style="text-align:right;">
			{{form.withholdings | currency: 'Q'}}
			<i class="fa fa-copy" tooltip="Copiar al portapapeles" style="display: none;"></i>
		</p>
	</div>
</div>
<div class="row" style="padding-left: 1em; padding-right: 1em;">
	<div class="col">
		Costos y gastos acumulados:
	</div>
	<div class="col">
		<p class="text-info text-copy" (click)="copy(form.costNExpenses)" style="text-align:right;">
			{{form.costNExpenses | currency: 'Q'}}
			<i class="fa fa-copy" tooltip="Copiar al portapapeles" style="display: none;"></i>
		</p>
	</div>
</div>
<div class="row" style="padding-left: 1em; padding-right: 1em;">
	<div class="col">
		Costos y gastos para la generacion de rentas excentas y no afectas acumulados:
	</div>
	<div class="col">
		<p class="text-info text-copy" (click)="copy(form.taxesContributions)" style="text-align:right;">
			{{form.taxesContributions | currency: 'Q'}}
			<i class="fa fa-copy" tooltip="Copiar al portapapeles" style="display: none;"></i>
		</p>
	</div>
</div>
<div class="row" style="padding-left: 1em; padding-right: 1em;">
	<div class="col">
		Costos y gastos no deducibles:
	</div>
	<div class="col">
		<p class="text-info text-copy" (click)="copy(form.nonDeductibleExpense)" style="text-align:right;">
			{{form.nonDeductibleExpense | currency: 'Q'}}
			<i class="fa fa-copy" tooltip="Copiar al portapapeles" style="display: none;"></i>
		</p>
	</div>
</div>
<div class="row" style="padding-left: 1em; padding-right: 1em;">
	<div class="col">
		Renta imponible acumulada:
	</div>
	<div class="col">
		<p class="text-info text-copy" (click)="copy(form.accumulatedTaxIncome)" style="text-align:right;">
			{{form.accumulatedTaxIncome | currency: 'Q'}}
			<i class="fa fa-copy" tooltip="Copiar al portapapeles" style="display: none;"></i>
		</p>
	</div>
</div>
<div class="row" style="padding-left: 1em; padding-right: 1em;">
	<div class="col">
		Pérdida fiscal acumulada:
	</div>
	<div class="col">
		<p class="text-info text-copy" (click)="copy(form.accumulatedTaxLoss)" style="text-align:right;">
			{{form.accumulatedTaxLoss | currency: 'Q'}}
			<i class="fa fa-copy" tooltip="Copiar al portapapeles" style="display: none;"></i>
		</p>
	</div>
</div>
<div class="row" style="padding-left: 1em; padding-right: 1em;">
	<div class="col">
		Impuesto sobre la renta:
	</div>
	<div class="col">
		<p class="text-info text-copy" (click)="copy(form.taxesToPay)" style="text-align:right;">
			{{form.taxesToPay | currency: 'Q'}}
			<i class="fa fa-copy" tooltip="Copiar al portapapeles" style="display: none;"></i>
		</p>
	</div>
</div>
<div class="row" style="padding-left: 1em; padding-right: 1em;">
	<div class="col">
		Impuesto sobre la renta aculumada del trimestre Inmediato anterior:
	</div>
	<div class="col">
		<p class="text-info text-copy" (click)="copy(form.totalToPayPast)" style="text-align:right;">
			{{form.totalToPayPast | currency: 'Q'}}
			<i class="fa fa-copy" tooltip="Copiar al portapapeles" style="display: none;"></i>
		</p>
	</div>
</div>
<div class="row" style="padding-left: 1em; padding-right: 1em;">
	<div class="col">
		Impuesto determinado en este trimestre:
	</div>
	<div class="col">
		<p class="text-info text-copy" (click)="copy(form.taxDeterminedThisQuarter)" style="text-align:right;">
			{{form.taxDeterminedThisQuarter | currency: 'Q'}}
			<i class="fa fa-copy" tooltip="Copiar al portapapeles" style="display: none;"></i>
		</p>
	</div>
</div>